/**
 * 用户行为上报方法集
 */

// 用户上报的白名单用户列表
export const QtReportWhiteListUser = ['000888', '093263', '092882', '000822', '609695', '633664']

// 判断当前用户是否为白名单用户人员
export const isQtReportWhiteList = () => {
  const userInfo = window.__ERPUSER__
  const needReport = userInfo && QtReportWhiteListUser.includes(userInfo.employeeNumber)
  return needReport
}

// 路由跳转至 404 页面
export const QtReportRouteTo404 = (from) => {
  try {
    setTimeout(() => {
      const detail = {
        fullPath: from.fullPath,
        meta: from.meta
      }
      window.aplus_queue && window.aplus_queue.push({
        'action': 'aplus.record',
        'arguments': ['erp_common_to_404', 'OTHER', {
          detail: JSON.stringify(detail)
        }]
      })
    })
  } catch (error) {
    window._apm && window._apm('captureException', new Error(`QtReportRouteTo404${error}`))
  }
}

// 路由跳转至 405 页面
export const QtReportRouteTo405 = (from) => {
  try {
    setTimeout(() => {
      const detail = {
        fullPath: from.fullPath,
        meta: from.meta
      }
      window.aplus_queue && window.aplus_queue.push({
        'action': 'aplus.record',
        'arguments': ['erp_common_to_405', 'OTHER', {
          detail: JSON.stringify(detail)
        }]
      })
    })
  } catch (error) {
    window._apm && window._apm('captureException', new Error(`QtReportRouteTo405${error}`))
  }
}

// 用户通过左侧菜单点击打开模块
export const QtReportOpenModuleByLeftMenu = (path) => {
  try {
    setTimeout(() => {
      const detail = {
        path,
      }
      window.aplus_queue && window.aplus_queue.push({
        'action': 'aplus.record',
        'arguments': ['erp_common_left_menu_click', 'OTHER', {
          detail: JSON.stringify(detail)
        }]
      })
    })
  } catch (error) {
    window._apm && window._apm('captureException', new Error(`QtReportOpenModuleByLeftMenu${error}`))
  }
}

// 上报用户关闭页面的用户行为
export const QtReportCloseTags = (tags, type) => {
  try {
    setTimeout(() => {
      const detail = {
        path: tags,
        type
      }
      window.aplus_queue && window.aplus_queue.push({
        'action': 'aplus.record',
        'arguments': ['erp_common_top_tab_close_click', 'OTHER', {
          detail: JSON.stringify(detail)
        }]
      })
    })
  } catch (error) {
    window._apm && window._apm('captureException', new Error(`QtReportCloseTags${error}`))
  }
}

// 用户手动切换页签
export const QtReportChangeTab = (path) => {
  try {
    setTimeout(() => {
      const detail = {
        path,
      }
      window.aplus_queue && window.aplus_queue.push({
        'action': 'aplus.record',
        'arguments': ['erp_common_top_tab_click', 'OTHER', {
          detail: JSON.stringify(detail)
        }]
      })
    })
  } catch (error) {
    window._apm && window._apm('captureException', new Error(`QtReportChangeTab${error}`))
  }
}

// 用户登录铸剑（区分首次登录和二次登录） 二次登录：token过期
export const QtReportUserLogin = () => {
  try {
    setTimeout(() => {
      const detail = {
        isLoginAgain: Boolean(window.__ERP_IS_AGAIN_LOGIN)
      }
      window.aplus_queue && window.aplus_queue.push({
        'action': 'aplus.record',
        'arguments': ['erp_common_user_login', 'OTHER', {
          detail: JSON.stringify(detail)
        }]
      })
    }, 3000)
  } catch (error) {
    window._apm && window._apm('captureException', new Error(`QtReportUserLogin${error}`))
  }
}

// 用户通过搜索查询打开模块
export const QtReportOpenMenuBySearch = (path) => {
  try {
    setTimeout(() => {
      const detail = {
        path,
      }
      window.aplus_queue && window.aplus_queue.push({
        'action': 'aplus.record',
        'arguments': ['erp_common_left_menu_search', 'OTHER', {
          detail: JSON.stringify(detail)
        }]
      })
    })
  } catch (error) {
    window._apm && window._apm('captureException', new Error(`QtReportOpenMenuBySearch${error}`))
  }
}

// 用户通过常用模块打开模块
export const QtReportOpenMenuByFavorite = (path) => {
  try {
    setTimeout(() => {
      const detail = {
        path,
      }
      window.aplus_queue && window.aplus_queue.push({
        'action': 'aplus.record',
        'arguments': ['erp_common_favorite_menu_click', 'OTHER', {
          detail: JSON.stringify(detail)
        }]
      })
    })
  } catch (error) {
    window._apm && window._apm('captureException', new Error(`QtReportOpenMenuByFavorite${error}`))
  }
}

// 上报用户接口调用
export const QtReportHttpRequest = (response) => {
  try {
    setTimeout(() => {
      // 判断是否为白名单人员
      if (isQtReportWhiteList()) {
        const { data, config, message } = response
        const endTime = Date.now()
        const duration = endTime - (config && config.startTime)
        const traceId = (data && data.traceId) || null
        const msg = message || (data && data.msg) || ''
        const method = (config && config.headers && config.headers.method) || ''
        const menuId = (config && config.headers && config.headers['X-menu-id']) || ''
        const actionDom = config && config.actionDom
        const detail = {
          traceId,
          method,
          menuId,
          duration,
          actionDom,
          dom: window.__ERP_LASTEVENT__,
          lastTag: window.__ERP_LASTTAG__,
          msg
        }
        window.aplus_queue && window.aplus_queue.push({
          'action': 'aplus.record',
          'arguments': ['erp_common_http_request', 'OTHER', {
            detail: JSON.stringify(detail)
          }]
        })
      }
    })
  } catch (error) {
    window._apm && window._apm('captureException', new Error(`QtReportHttpRequest${error}`))
  }
}




// WEBPACK FOOTER //
// ./src/layout/utils/report-qt.js